var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "tos" },
    [
      _c(
        "modal",
        {
          attrs: {
            name: "tos",
            adaptive: true,
            scrollable: true,
            reset: true,
            width: "60%",
            height: "auto",
          },
          on: { "before-open": _vm.fetchTos },
        },
        [
          _c("div", { staticClass: "modal__content" }, [
            _c("div", {
              staticClass: "tos",
              domProps: { innerHTML: _vm._s(_vm.tosContent) },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "modal__footer" }, [
              _c(
                "span",
                {
                  staticClass: "btn btn--hollow btn--small",
                  on: { click: _vm.rejectTos },
                },
                [_vm._v("En hyväksy")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn--call-to-action btn--small",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.acceptTos.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n                    OK\n                ")]
              ),
            ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "accept-terms" }, [
        _c("div", { staticClass: "checkbox" }, [
          _c("label", { staticClass: "inline", attrs: { for: "tosChecked" } }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.accepted,
                  expression: "accepted",
                },
              ],
              staticClass: "inline",
              attrs: { type: "checkbox", id: "tosChecked", name: "tosChecked" },
              domProps: {
                checked: Array.isArray(_vm.accepted)
                  ? _vm._i(_vm.accepted, null) > -1
                  : _vm.accepted,
              },
              on: {
                change: [
                  function ($event) {
                    var $$a = _vm.accepted,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.accepted = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.accepted = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.accepted = $$c
                    }
                  },
                  _vm.onChange,
                ],
              },
            }),
            _vm._v("\n                Hyväksyn "),
            _c("a", { on: { click: _vm.openTos } }, [_vm._v("tilausehdot")]),
            _vm.hasContract ? _c("span", [_vm._v(" sekä ")]) : _vm._e(),
            _vm._v(" "),
            _vm.hasContract
              ? _c("a", { attrs: { href: _vm.contractDownloadUrl } }, [
                  _vm._v("bändin sopimusehdot "),
                ])
              : _vm._e(),
            _vm._v(" ja sitoudun noudattamaan niitä\n            "),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }